import {validateRequired} from "./ValidationFunctions";

const certificationFormConfig = {
  fields: {
    name: {
      type: 'text',
      label: 'Name',
      rules: [validateRequired('Name')]
    },
    startAt: {
      type: 'date',
      label: 'Starts at',
      placeholder: 'Starts at',
      rules: [validateRequired('Starts at')]
    },
    expireAt: {
      type: 'date',
      label: 'Expire at',
      placeholder: 'Expire at',
      rules: [validateRequired('Expire at')]
    },
  }
};

export {
  certificationFormConfig
}
